import React, { Fragment } from 'react';
import { Card, CardBody, Col, Container, Row, Button, Input } from 'reactstrap';
import { useUnits } from '../../hooks/units/useUnits';
import { TableStriped } from '../../components/tables/TableStriped';
import { ModalUnit } from '../../components/units/ModalUnit';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';


export const IndexUnits = (props) => {
    const {
        units, method, handleCreate, unit,
        abbreviation, handleInputChange, closeDialog,
        modal, loading, saveCreate, handleUpdate,
        saveUpdate, handleDelete, saveDelete,
        showDeleteAlert, modalAlert, closeDeleteAlert,
        handleExcelUnit, loadingExcel, handleSearchUnit,
        handleClearUnit, searchUnit

    } = useUnits();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_unit)}
                    title="Editar sucursal"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_unit)}
                    title="Serie y folio para facturas"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                <TitleDataTable
                                    titleTable="Listado de unidades"
                                    buttonActions={handleExcelUnit}
                                    titleButton="Listado de tipos de transporte"
                                    isDisbled={loadingExcel}
                                    loadingIsDisabled={loadingExcel}
                                    titleCreate="Crear unidad"
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearchUnit}
                                    valueFilter={searchUnit}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearUnit}
                                />

                                <div className="table-responsive">
                                    <DataTable
                                        value={units}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column
                                            field="unit"
                                            header="Nombre"
                                            sortable
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.unit}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />

                                        <Column
                                            field="abbreviation"
                                            sortable
                                            header="Abreviación"
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.abbreviation}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle} />

                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ModalUnit
                {...{ modal, closeDialog, loading, method, unit, abbreviation, handleInputChange, saveCreate, saveUpdate, saveDelete }}
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar unidad"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la unidad?"
                    alert1={true}
                    titleAlert1={unit}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                    maskClassName="custom-total-mask"
                    newDesingDialog={true}
                    iconNewDialog="fa fa-trash-o f-20"
                    headerColor="#8b0000"
                    newDesingDialogDelete={true}
                    closable={false}
                />
            )}

        </Fragment>
    )
}
